export default __webpack_public_path__ + "static/media/featured-img.2b747592.jpg";